import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { DepartmentResource } from 'app/models/DepartmentResource';
import { DepartmentScheduleIntervalListResponse } from 'app/models/DepartmentScheduleIntervalListResponse';
import { DepartmentScheduleListResponse } from 'app/models/DepartmentScheduleListResponse';
import { DepartmentScheduleRequest } from 'app/models/DepartmentScheduleRequest';
import { DepartmentScheduleResponse } from 'app/models/DepartmentScheduleResponse';
import { UtilsService } from 'app/services/utils.service';
import { combineLatest, forkJoin } from 'rxjs';
import { map, tap } from 'rxjs/operators';


@Component({
  selector: 'add-edit-appointment-department',
  templateUrl: './add-edit-appointment-department.component.html',
  styleUrls: ['./add-edit-appointment-department.component.scss']
})
export class AddEditAppointmentDepartmentComponent implements OnInit {

  //setups for calendar example
  //From : https://www.primefaces.org/primeng/showcase/#/calendar
  // value: Array<Date>;
  // minDate: Date;
  // maxDate: Date;
  // invalidDates: Array<Date>;

  validationForm: FormGroup;
  department: DepartmentResource;
  selected_language: string = "ro";
  tooltipOptions = {
    'placement': 'right',
  }
  errorMessage: any;
  intervalsError: string;
  intervalsErrorId: number = -1;
  saveErrors: boolean = false;
  departmentId: number;
  displayStep2: boolean = false;

  selectedDays: Array<Date>
  departmentScheduleListResponse: DepartmentScheduleListResponse;
  departmentScheduleRequest: DepartmentScheduleRequest;
  startHour: Date;
  endHour: Date;

  dateFormat: string = "yyyy-MM-dd";
  locale: string = "en-US";
  currentSelectedMonth = "";
  currentSelectedYear = "";
  minDate: Date;

  depScheduleIntervalsList: DepartmentScheduleIntervalListResponse;
  correctEmail: boolean = false;

  constructor(private fb: FormBuilder,
    private utilsService: UtilsService,
    private translate: TranslateService,
    private _notificationService: NotificationsService,
    private activateRoute: ActivatedRoute,
    private router: Router) {
    this.department = new DepartmentResource();
    this.departmentScheduleListResponse = new DepartmentScheduleListResponse();
    this.departmentScheduleListResponse.calendarSchedule = new Array<DepartmentScheduleResponse>();
    this.departmentScheduleRequest = new DepartmentScheduleRequest();

    this.depScheduleIntervalsList = new DepartmentScheduleIntervalListResponse();
    this.depScheduleIntervalsList.intervals = [];
    this.depScheduleIntervalsList.errorDays = [];
    
  }

  ngOnInit() {
    //   setups for Calendar example
    //   let today = new Date();
    //   this.minDate = new Date(new Date(today.getTime() - (20 /*days*/ * 24 * 60 * 60 * 1000)));
    //   this.maxDate = new Date(new Date(today.getTime() + (20/*days*/ * 24 * 60 * 60 * 1000)));

    //   let secondInvalidDate = new Date();
    //   secondInvalidDate.setDate(today.getDate() - 1);
    //   this.invalidDates = [today, secondInvalidDate];  


    this.minDate = new Date();
    
    this.validationForm = this.fb.group({
      departmentNameRo: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      departmentNameEn: [''],
      departmentNameFr: [''],
      departmentNameDe: [''],
      responsible: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      emailResponsible: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.email]],
      periodAvailability: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      // isActive: [false, [Validators.required]]

    })

    this.activateRoute.params.subscribe(
      (params: Params) => {
        if ('json' in params) {
          this.departmentId = JSON.parse(atob(params['json'])).departmentId;
          this.getDepartment();
        }
      }
    )

  }
  onSubmitStep1() {
    if (!this.validationForm.valid) {
      this.saveErrors = true;
      forkJoin(
        [this.translate.get('Error'),
        this.translate.get(`Required fields`)]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      return;
    }
    let checkEmail = this.department.responsibleEmail.indexOf('@');
    if (this.department.responsibleEmail.includes('.', checkEmail)) {
      this.correctEmail = false;
    }
    else {
      this.correctEmail = true;
      return;
    }

    this.department.userEmail = this.utilsService.currentUserEmail;
    this.utilsService.add('/admin/department/addEdit', this.department)
      .subscribe(
        (response: DepartmentResource) => {
          if (response.errorCode === 0) {
            this.department = response;
            this.departmentId = this.department.id;
            this.displayStep2 = true;
            forkJoin(
              [this.translate.get('Department details'),
              this.translate.get(`Department added with success`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            })
          } else {
            if (response.errorCode === 10901) {
              forkJoin(
                [this.translate.get('Error'),
                this.translate.get(`Department not found`)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
            }
            if (response.errorCode === 10900) {
              forkJoin(
                [this.translate.get('Error'),
                this.translate.get(`You do not have rights for this`)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
            }
          }
        },
        err => this.errorMessage = err
      )
  }

  removeDays() {
    if (!this.selectedDays) {
      forkJoin(
        [this.translate.get('Error'),
        this.translate.get(`You have to select days to clear`)]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      return
    }

    this.departmentScheduleRequest.departmentId = this.department.id;
    this.departmentScheduleRequest.scheduleDayList = this.formatSelectedDays();
    this.utilsService.add('/admin/department/removeDepartmentSchedule', this.departmentScheduleRequest)
      .subscribe(
        (response: DepartmentScheduleListResponse) => {
          if (response.errorCode === 0) {
            this.departmentScheduleListResponse = response;
            this.selectedDays = undefined;
          } else {
            if (response.errorCode === 10913) {
              forkJoin(
                [this.translate.get('Error'),
                this.translate.get(`You can not change dates with appointments assigned to them`)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
            }

          }
        }
      )

  }


  onSubmitStep2() {
    this.departmentScheduleRequest.departmentId = this.department.id;
    this.departmentScheduleRequest.scheduleDayList = this.formatSelectedDays();
    this.departmentScheduleRequest.scheduleStartHour = ((this.startHour.getHours() < 10) ? "0" + this.startHour.getHours() : this.startHour.getHours())
      + ":"
      + ((this.startHour.getMinutes() < 10) ? "0" + this.startHour.getMinutes() : this.startHour.getMinutes());
    this.departmentScheduleRequest.scheduleEndHour = ((this.endHour.getHours() < 10) ? "0" + this.endHour.getHours() : this.endHour.getHours())
      + ":"
      + ((this.endHour.getMinutes() < 10) ? "0" + this.endHour.getMinutes() : this.endHour.getMinutes());

    let errMsg = "";
    this.intervalsErrorId = -1;
    for (let i = 0; i < this.depScheduleIntervalsList.intervals.length; i++) {
      let element = this.depScheduleIntervalsList.intervals[i];
      errMsg = this.checkValue(element.totalSlots, element.ocupiedSlots);
      if (errMsg) {
        forkJoin(
          [this.translate.get('Error'),
          this.translate.get(errMsg),
          this.translate.get("See interval no"),
          ]
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1] + "---" + res[2] + " " + (i + 1), 'error')
        })
        this.intervalsErrorId = i;
        break
      }
    }

    if (errMsg !== "") {
      return;
    }

    this.departmentScheduleRequest.intervals = Array.from(this.depScheduleIntervalsList.intervals);
    this.utilsService.add('/admin/department/addEditDepartmentSchedule', this.departmentScheduleRequest)
      .subscribe(
        (response: DepartmentScheduleListResponse) => {
          if (response.errorCode === 0) {
            this.departmentScheduleListResponse = response;
            this.selectedDays = undefined;
            this.startHour = undefined;
            this.endHour = undefined;
            this.departmentScheduleRequest.appointmentDuration = undefined
            this.depScheduleIntervalsList.intervals = [];
            this.intervalsError = undefined;
          } else {
            if (response.errorCode === 10912) {
              forkJoin(
                [this.translate.get('Error'),
                this.translate.get(`Start Hour should be before End Hour`)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
            } else {
              if (response.errorCode === 10911) {
                forkJoin(
                  [this.translate.get('Error'),
                  this.translate.get(`Use a lower value for appointment duration`)]
                ).subscribe((res) => {
                  this._notificationService.create(res[0], res[1], 'error')
                })
              } else {
                if (response.errorCode === 10913) {
                  let days = " Days" + ": " + response.errorDays.join(" ; ");
                  forkJoin(
                    [this.translate.get('Error'),
                    this.translate.get(`You can not change dates with appointments assigned to them`)]
                  ).subscribe((res) => {
                    this._notificationService.create(res[0], res[1] + days, 'error')
                  })
                }
              }
            }
          }
        },
        err => this.errorMessage = err

      )
  }

  formatSelectedDays(): Array<string> {

    let days = new Array<string>();
    this.selectedDays.forEach(d => {
      /*       let year = d.getFullYear();
            let month = (d.getMonth() < 9) ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1);
            let day = (d.getDate() < 10) ? "0" + d.getDate() : d.getDate(); */
      let formatedDay = formatDate(d, this.dateFormat, this.locale);
      days.push(formatedDay)
    })
    return days
  }

  getDepartment() {
    let requestParam = "";
    if (this.currentSelectedMonth !== "") {
      requestParam = "?month=" + this.currentSelectedMonth
    }

    if (this.currentSelectedYear !== "") {
      requestParam += "&year=" + this.currentSelectedYear
    }

    combineLatest([
      this.utilsService.get(`/admin/department/getDepartmentById/${this.departmentId}`),
      this.utilsService.get(`/admin/department/getCalendarSchedule/${this.departmentId}${requestParam}`)
    ])
      .pipe(
        tap(data => console.log("response = ", data)),
        map(([departmentResponse, scheduleResponse]) => {
          if (departmentResponse.errorCode === 0) {
            this.department = departmentResponse;
          } else {
            if (departmentResponse.errorCode === 10901) {
              forkJoin(
                [this.translate.get('Error'),
                this.translate.get(`Department not found`)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
            }
          }
          this.departmentScheduleListResponse = scheduleResponse;
        })
      )
      .subscribe(
        complete => {
          this.displayStep2 = true;
        }
      )

  }

  //highlight  the days already saved
  markedDates(date): string {
    const currentdate = formatDate(new Date(date.year + "-" + (date.month + 1) + "-" + date.day), this.dateFormat, this.locale) + "";
    const ob = this.departmentScheduleListResponse.calendarSchedule.filter(x => formatDate(x.scheduleDay, this.dateFormat, this.locale) === currentdate);
    return (ob.length > 0) ? '#81C784' : 'inherit';
  }

  onDaySelected(day: Date) {
    console.log("====>>> onday selected ", day);
    if (this.selectedDays && this.selectedDays.length === 1) {
      let selDate = day;
      let selectedDate = formatDate(day, this.dateFormat, this.locale);
      let founded: DepartmentScheduleResponse = this.departmentScheduleListResponse.calendarSchedule.find(x => x.scheduleDay === selectedDate);
      if (founded) { //if the selected day in calendar is already settled
        const sh = selDate.setHours(+founded.scheduleStartHour.split(":")[0], +founded.scheduleStartHour.split(":")[1])
        this.startHour = new Date(sh);
        const eh = selDate.setHours(+founded.scheduleEndHour.split(":")[0], +founded.scheduleEndHour.split(":")[1])
        this.endHour = new Date(eh);
        this.departmentScheduleRequest.appointmentDuration = founded.appointmentDuration;
        /* for(let i=0; i<founded.intervals.length; i++ ){
          this.depScheduleIntervalsList.intervals.push({...founded.intervals[i]});
        } */
        this.depScheduleIntervalsList.intervals = founded.intervals.map((interval) => ({ ...interval, ocupiedSlots: interval.totalSlots - interval.availableSlots }))
      } else {
        this.startHour = this.endHour = this.departmentScheduleRequest.appointmentDuration = undefined;
        this.depScheduleIntervalsList.intervals = [];
        this.intervalsError = undefined;
      }
    } else {
      this.startHour = this.endHour = this.departmentScheduleRequest.appointmentDuration = undefined;
      this.depScheduleIntervalsList.intervals = [];
      this.intervalsError = undefined;
    }
  }

  onStartHourSelection(ev) {
    if (this.depScheduleIntervalsList.intervals.length > 0) {
      this.depScheduleIntervalsList.intervals = [];
      this.intervalsError = undefined;
    }
  }

  onEndHourSelection(ev) {
    if (this.depScheduleIntervalsList.intervals.length > 0) {
      this.depScheduleIntervalsList.intervals = [];
      this.intervalsError = undefined;
    }
  }

  onAppointmentSelection(ev) {
    if (this.depScheduleIntervalsList.intervals.length > 0) {
      this.depScheduleIntervalsList.intervals = [];
      this.intervalsError = undefined;
    }
  }

  onMonthChange(ev) {
    this.currentSelectedMonth = ev.month;
    this.currentSelectedYear = ev.year;
    this.getDepartment();
  }

  generateAppointmentsIntervals() {
    this.intervalsError = undefined;

    if (!this.selectedDays || !this.startHour || !this.endHour
      || !this.departmentScheduleRequest.appointmentDuration) {
      forkJoin(
        [this.translate.get('Error'),
        this.translate.get(`All fields must be completed`)]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      return
    }
    let isValid = true;
    if (this.selectedDays && this.selectedDays.length === 0) {
      isValid = false;
      forkJoin(
        [this.translate.get('Error'),
        this.translate.get(`Please, select at least one day in the calendar!`)]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }

    if (this.startHour >= this.endHour) {
      isValid = false;
      forkJoin(
        [this.translate.get('Error'),
        this.translate.get(`Start Hour should be before End Hour`)]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }
    const regexp = /^[0-9]\d*$/;
    if (!regexp.test(this.departmentScheduleRequest.appointmentDuration + "")) {
      isValid = false;
      forkJoin(
        [this.translate.get('Error'),
        this.translate.get(`Appointment duration should be a positive number`)]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }
    if (!isValid) { return };

    this.departmentScheduleRequest.departmentId = this.department.id;
    this.departmentScheduleRequest.scheduleDayList = this.formatSelectedDays();
    this.departmentScheduleRequest.scheduleStartHour = ((this.startHour.getHours() < 10) ? "0" + this.startHour.getHours() : this.startHour.getHours())
      + ":"
      + ((this.startHour.getMinutes() < 10) ? "0" + this.startHour.getMinutes() : this.startHour.getMinutes());
    this.departmentScheduleRequest.scheduleEndHour = ((this.endHour.getHours() < 10) ? "0" + this.endHour.getHours() : this.endHour.getHours())
      + ":"
      + ((this.endHour.getMinutes() < 10) ? "0" + this.endHour.getMinutes() : this.endHour.getMinutes());
    this.utilsService.add('/admin/department/calculateIntervals', this.departmentScheduleRequest)
      .subscribe(
        (response: DepartmentScheduleIntervalListResponse) => {
          console.log("=====>>> response = ", response)
          let days = "";
          if (response.errorCode === 0) {
            this.depScheduleIntervalsList = response;
            /*  this.departmentScheduleRequest.intervals.forEach(x=>{
               x.ocupiedSlots = x.totalSlots - x.availableSlots;
             }) */
            this.depScheduleIntervalsList.intervals.map((interval) => ({ ...interval, ocupiedSlots: interval.totalSlots - interval.availableSlots }))
            forkJoin(
              [this.translate.get('Department schedule intervals'),
              this.translate.get(`Department schedule intervals generated`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            })
          } else {
            let errMsg = "";
            switch (response.errorCode) {
              case 10911:
                errMsg = "Appointment duration is too long"; break;

              case 10912:
                errMsg = "Start Hour should be before End Hour"; break;

              case 10913:
                if(response.errorDays){
                    days = ": " + response.errorDays.join(" ; ");
                    errMsg = "You can not change days with appointments assigned on them. Days";
                }else{
                  errMsg = "You can not change days with appointments assigned on them."; 
                }
                break;
            }
            if (errMsg !== "") {
              forkJoin(
                [this.translate.get('Error'),
                this.translate.get(errMsg)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1] + days, 'error')
              })
            }
          }

        },
        err => this.errorMessage = err
      )
  }

  back() {
    return this.router.navigate(['/departments-list']);

  }

  checkValue(tSlots, oSlots): string {
    this.intervalsError = undefined;
    const regexp = /^[0-9]\d*$/;
    if (!regexp.test(tSlots + "")) {
      this.intervalsError = "Total slots value should be a number"
    }
    if (tSlots < oSlots) {
      this.intervalsError = "Total slots value should be bigger or equal than the ocupied slots"
    }
    return this.intervalsError || ""
  }


}
